import React from "react";
import PropTypes from "prop-types";

import { Icon } from "@lululemon/ui-library";
import * as AllIcons from "@lululemon/ui-icons";

import styles from "./card-subcontent.module.scss";

const ActivityIcon = ({ iconName = "" }) => {
  const IconComponent = AllIcons[iconName];

  if (!IconComponent) return null;

  return <Icon className={styles.icon} content={IconComponent} />;
};

const getWebElementText = (content) => {
  const text = content?.find(
    (item) => item.sys?.contentType?.sys?.id === "webElementText"
  );
  return text?.fields?.title;
};

export const CardSubcontent = ({ content }) => {
  const iconListContent = content.find(
    (item) =>
      item.sys?.contentType?.sys?.id === "webComponentCardCarouselIconList"
  );

  if (iconListContent) {
    return (
      <ul className={styles.iconList}>
        {iconListContent?.fields?.list.map((listItem) => (
          <li className={styles.iconListItem} key={listItem.sys?.id}>
            <ActivityIcon iconName={listItem.fields?.icon} />
            {listItem.fields?.text}
          </li>
        ))}
      </ul>
    );
  }

  return getWebElementText(content);
};

CardSubcontent.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.oneOf([
      {
        sys: {
          contentType: {
            sys: PropTypes.string,
          },
        },
        fields: {
          list: PropTypes.arrayOf({
            sys: {
              id: PropTypes.string,
            },
            fields: {
              icon: PropTypes.string,
              text: PropTypes.string,
            },
          }),
        },
      },
      {
        sys: {
          contentType: {
            sys: PropTypes.string,
          },
        },
        fields: {
          title: PropTypes.string,
        },
      },
    ])
  ).isRequired,
};
